export default __webpack_public_path__ + "static/centralizedRecords-6f8ff56cd1c842c1e74cd64f2258688d.jpg";